<template>
  <!-- Component not used. Left for better times. -->
  <div>
    <main-large-dialog
      :is-valid="isTableTab && watermetersLength > 0 ? true : isValid"
      :is-visible.sync="computedIsVisible"
      :title="
        isTableTab ? $i18n.t('sidebar.locks.listOfWatermetersInFailure') : $i18n.t('dialog.title.notifyAboutFailure')
      "
      :agree-text="isTableTab ? 'dialog.addKomadresOrder' : 'dialog.agreeSend'"
      :dialog-width="`${isTableTab ? '6' : '4'}0%`"
      min-body-height="40vh"
      @agree="isTableTab ? addKomadresOrder() : openConfirmModal()"
      no-paddings-x
      no-paddings-y
      :header-shadow="!isSmsEnabled"
    >
      <template #body>
        <template v-if="isFetched">
          <grey-tabs
            v-model="currentTab"
            :tabs="tabs"
            :show-arrows="false"
            fill-height
            fill-width
            :tabs-visible="isSmsEnabled"
          >
            <v-tab-item v-if="isSmsEnabled">
              <v-col cols="12" class="py-0 px-4">
                <v-form v-model="isValid">
                  <v-col cols="12" class="pa-0">
                    <v-row no-gutters align="center">
                      <v-col cols="auto">{{ $i18n.t('dialog.estimatedDateOfFailureRemoval') }}:</v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="auto">
                        <v-icon class="pr-1" color="rgba(0,0,0,0.7)" size="20px">mdi-calendar</v-icon>
                      </v-col>
                      <v-col cols="4">
                        <data-input
                          :data-type="dataType"
                          v-model="failureRepairDateTime"
                          :rules="[v => !!v || $i18n.t('rules.required')]"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="py-5 divider-row">
                      <v-col class="message-preview">
                        <v-row no-gutters class="pt-2 pl-2 message-preview-info">
                          {{ $i18n.t('dialog.messagePreview') }}
                        </v-row>
                        <v-row no-gutters class="py-5 px-10 text-justify message-preview-content">
                          {{ locksMessageSchema }}
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="center" class="mt-3" style="min-height: 45px">
                      <v-col cols="auto">{{ $i18n.t('dialog.waterMetersNumber') }}:</v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="4" class="text-left">
                        {{ watermetersLength }}
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="center" style="min-height: 45px">
                      <v-col cols="auto">{{ $i18n.t('dialog.assignedPhoneNumbersNumber') }}: </v-col>
                      <v-spacer></v-spacer>
                      <v-col cols="4" class="text-left">
                        {{ locksAvailablePhoneNumbers }}
                      </v-col>
                    </v-row>
                    <v-row no-gutters align="center" class="warning-span mt-2">
                      <v-col cols="auto" class="warning-icon px-1">
                        <v-icon class="px-1 py-2" color="rgba(255,255,255,1)">mdi-alert</v-icon>
                      </v-col>
                      <v-col cols="11" class="warning-text pl-3">{{ $i18n.t('dialog.sendMessageWarning') }}</v-col>
                    </v-row>
                  </v-col>
                </v-form>
              </v-col>
            </v-tab-item>
            <v-tab-item class="pt-0">
              <v-col cols="1">
                <base-button class="my-2 mr-0" translation-path="dialog.download" @click="downloadWatermetersCsv" />
              </v-col>
              <v-col cols="12" class="pa-0">
                <layer-features-data-table
                  ref="locksWatermetersTable"
                  :layer-id="watermetersLayerId"
                  :empty-without-filter="true"
                  :filtered-objects-ids="watermetersResult"
                  :table-props="{ 'hide-default-footer': true, 'disable-pagination': true }"
                />
              </v-col>
            </v-tab-item>
          </grey-tabs>
        </template>
        <main-loader class="pt-10" v-else />
        <main-dialog
          v-if="isConfirmModalLoaded"
          :is-visible.sync="isConfirmModalVisible"
          :title="$i18n.t('dialog.notifyRecipients')"
          :loading="isConfirmModalLoading"
          agree-text="dialog.agreeSend"
          @agree="confirmSendingMessage"
        >
          <template #body>
            <v-subheader style="height: 80px" class="text-left px-0">
              {{ $i18n.t('dialog.notifyRecipientsBody') }}
            </v-subheader>
          </template>
        </main-dialog>
      </template>
    </main-large-dialog>
    <quick-komadres-order
      v-if="isKomadresDialogLoaded"
      :is-visible.sync="isKomadresDialogVisible"
      :layer-id="watermetersLayerId"
      :selected-features="watermetersResult"
    />
  </div>
</template>
<script>
import { call, get } from 'vuex-pathify';

import DataInput from '@/components/DataInput';
import MainLoader from '@/components/MainLoader';
import GreyTabs from '@/components/GreyTabs';
import LayerFeaturesDataTable from '@/components/LayerFeaturesDataTable';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'LocksAnalysisSmsModal',
  components: {
    MainDialog: () => import('@/components/MainDialog'),
    QuickKomadresOrder: () => import('@/components/QuickKomadresOrder'),
    DataInput,
    MainLargeDialog,
    MainLoader,
    GreyTabs,
    LayerFeaturesDataTable,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    currentTab: 0,
    dataType: {
      name: 'datetime',
    },
    failureRepairDateTime: '',
    isConfirmModalLoading: false,
    isConfirmModalVisible: false,
    isConfirmModalLoaded: false,
    isFetched: false,
    isValid: false,
    isKomadresDialogLoaded: false,
    isKomadresDialogVisible: false,
  }),
  computed: {
    cutoffResultWaterMeters: get('locks/cutoffResult@water_watermeters'),
    isSmsModuleEnabled: get('admin/additionalModules@SMS@enabled'),
    isSmsSettingEnabled: get('admin/settingsValues@sms_module_enabled'),
    locksAvailablePhoneNumbers: get('sms/locksAvailablePhoneNumbers'),
    locksMessageSchema: get('sms/locksMessageSchema'),
    watermetersLayerId: get('admin/modulesMapping@failures.cutoff_analysis_layers_ids.water_watermeters'),
    watermetersResult() {
      return this.cutoffResultWaterMeters ? this.cutoffResultWaterMeters : [];
    },
    watermetersLength() {
      return this.watermetersResult.length;
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    isTableTab() {
      return this.currentTab || !this.isSmsEnabled;
    },
    isSmsEnabled() {
      return this.isSmsSettingEnabled && this.isSmsModuleEnabled;
    },
    tabs() {
      const tabs = [{ name: this.$i18n.t('sidebar.locks.watermetersList') }];
      if (this.isSmsEnabled) {
        tabs.unshift({ name: this.$i18n.t('sidebar.locks.sendingMessages') });
      }
      return tabs;
    },
  },
  methods: {
    exportLayerFeatures: call('layers/exportLayerFeatures'),
    getLocksMessageSchema: call('sms/getLocksMessageSchema'),
    getLocksPhoneNumbers: call('sms/getLocksPhoneNumbers'),
    sendLocksSmsMessage: call('sms/sendLocksSmsMessage'),
    async init() {
      if (this.isSmsEnabled) {
        await Promise.all([
          this.getLocksPhoneNumbers({ watermeter_ids: this.cutoffResultWaterMeters }),
          this.getLocksMessageSchema(),
        ]);
      }
      this.isFetched = true;
    },
    async confirmSendingMessage() {
      this.isConfirmModalLoading = true;
      try {
        await this.sendLocksSmsMessage({
          estimated_failure_removal_datetime: this.failureRepairDateTime,
          watermeter_ids: this.cutoffResultWaterMeters,
        });
        this.isConfirmModalLoading = false;
        this.isConfirmModalVisible = false;
        this.computedIsVisible = false;
      } catch {
        this.isConfirmModalLoading = false;
      }
    },
    downloadWatermetersCsv() {
      const payload = { layer_id: this.watermetersLayerId, format: 'csv', features_filter: undefined };
      if (this.$refs.locksWatermetersTable && this.$refs.locksWatermetersTable.$data.currentFeaturesFilter) {
        payload.features_filter = this.$refs.locksWatermetersTable.$data.currentFeaturesFilter;
      }
      this.exportLayerFeatures(payload);
    },
    addKomadresOrder() {
      this.isKomadresDialogLoaded = true;
      this.isKomadresDialogVisible = true;
    },
    openConfirmModal() {
      this.isConfirmModalLoaded = true;
      this.isConfirmModalVisible = true;
    },
  },
  watch: {
    computedIsVisible: {
      immediate: true,
      handler(nV) {
        if (!nV) {
          this.failureRepairDateTime = '';
          this.isValid = false;
          this.isFetched = false;
          this.currentTab = 0;
        } else {
          this.init();
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.message-preview {
  max-width: 400px;
  margin: auto;
  padding: 5px 5px;
  background-color: rgba(215, 215, 215, 0.49);
  border-bottom: 1px solid #898989;
}
.message-preview-info {
  font-size: 9px;
  color: rgba(0, 0, 0, 0.59);
}
.message-preview-content {
  font-size: 15px;
  line-height: 21px;
}
.warning-span {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
.warning-icon {
  background-color: #ff8800;
}
.warning-text {
  text-align: left;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.divider-row {
  @include border(bottom);
}
::v-deep {
  .v-tabs {
    z-index: 99;
    position: sticky;
    top: 0;
  }
  .v-tabs-items {
    height: calc(100% - 48px);
    overflow: auto;
  }
  .v-slide-group {
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12) !important;
  }
}
</style>
